import { t } from "i18next";
import { useEffect, useState } from "react";
import ReactLoading from "react-loading";
import { useNavigate, useParams } from "react-router-dom";
import FormAccomplishments from "../../components/Form/FormAccomplishments/FormAccomplishments";
import ProfileDetails from "../../components/Profile/ProfileDetails/ProfileDetails";
import ProfilePermits from "../../components/Profile/ProfilePermits/ProfilePermits";
import ProfileTitle from "../../components/Profile/ProfileTitle/ProfileTitle";
import { Employee } from "../../contexts/interfaces";
import { useUserContext } from "../../contexts/UserContext";
import { getEmployee } from "../../scripts/dataHandlers";
import classes from "./ProfilePage.module.css";
import axios from "axios";
import { useErrorContext } from "../../contexts/ErrorContext";

const ProfilePage = () => {
  const [employee, setEmployee] = useState<Employee>();

  const { empUnit, empId } = useParams();

  const { user } = useUserContext();

  const { handleError } = useErrorContext();

  const navigate = useNavigate();

  useEffect(() => {
    // Create cancellation token for axios request
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const fetchData = async () => {
      // Get data for employee, using employeeId from url and userdata from context
      // unitId is set as default, as we are only asking for one employee
      // formData is null, as this is profileview
      const response =
        user &&
        (await getEmployee(user.id, undefined, Number(empId), null, source));

      if (response?.status === 200) {
        // Set employee to context
        setEmployee({ ...response.data.result[0] });
      } else {
        handleError(response, "GetEmployeeFailed");
      }
    };

    // If empId in url and user in context exists, fetch data. Otherwise navigate to login route
    if (empId && user) {
      fetchData();
    } else {
      navigate("/");
    }

    return () => source.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, empId, navigate]);

  return (
    <div className="mainContainer">
      <div className={classes.container}>
        {employee?.employeeId && user ? (
          <>
            <ProfileTitle
              employeeId={employee.employeeId}
              employeeName={`${employee.firstName} ${employee.lastName}`}
              employeeFormStatus={employee.formStatus}
              employeeFormId={employee.formId}
              employeeUnitId={Number(empUnit) || employee.expenseUnit}
            />
            <ProfileDetails
              dateOfBirth={employee.dateOfBirth}
              employeeName={`${employee.firstName} ${employee.lastName}`}
              registerNumber={employee.registerNumber}
              assignedRoles={employee.assignedRoles || []}
            />

            <div className={classes.accomplishmentsContainer}>
              <FormAccomplishments
                employeeAccomplishments={employee.accomplishments}
                fontSizeProps={"18px"}
                showOnlyRequired={false}
              />
            </div>

            <ProfilePermits employee={employee} setEmployee={setEmployee} />
          </>
        ) : (
          <div className={classes.loadingContainer}>
            <ReactLoading
              type={"spokes"}
              color={"#ED1B24"}
              height={"50px"}
              width={"50px"}
            />

            <div className={classes.profileLoadingText}>
              {`${t("profile.loading")}`}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfilePage;
